import {RedfactHelper} from "./RedfactHelper";

const DOMAIN_MM = 'mannheimer-morgen.de';
const DOMAIN_BA = 'bergstraesser-anzeiger.de';
const DOMAIN_SZ = 'schwetzinger-zeitung.de';
const DOMAIN_FN = 'fnweb.de';
const PUID_MM = 3;
const PUID_BA = 5;
const PUID_SZ = 6;
const PUID_FN = 7;
const REGEX_HOSTNAME = /https?:\/\/([^\/]*)(.*)/;
const REGEX_HOSTNAME_REDFACT = /https?:\/\/(www|red|prelive|red-prelive|integration|test\d+|xmedias\d+|dev\d+)?(-2025)?.(mannheimer-morgen|bergstraesser-anzeiger|schwetzinger-zeitung|fnweb).de/;
const REGEX_HOSTNAME_WWW2 = /https?:\/\/(authapi-epaper|www2|www2auth|www2tools)?-?(test)?[0-9]?.(mannheimer-morgen|bergstraesser-anzeiger|schwetzinger-zeitung|fnweb).de/;
const REGEX_HOSTNAME_EPAPER = /https?:\/\/e-paper.(mannheimer-morgen|bergstraesser-anzeiger|schwetzinger-zeitung|fnweb).de/;
const REGEX_GET_PUID = /[_]?puid[=,]{1}([0-9]+)/;
const USERAGENT_NEWSAPP_MM = 'MM_NewsApp';
const USERAGENT_NEWSAPP_BA = 'BA_NewsApp';
const USERAGENT_NEWSAPP_SZ = 'SZ_NewsApp';
const USERAGENT_NEWSAPP_FN = 'FN_NewsApp';

export class Environment {

  /**
   * constructor to create Environment instance
   * @return {object} Environment instance
   */
  constructor() {}

  isLocalhost() {
    return window.location.host.match(/^localhost/) !== null
      || window.location.host.match(/^172/) !== null;
  }

  isTestDatabaseEnvironment() {
    return window.location.host.match(/^(xmedias|dev|test|localhost|integration|www2authtest|www2tools-test)/) !== null;
  }

  getCurrentPuId () {

    let pu;

    /*
     * When developing, the puid can be explicitly in the url, then the domain is only fallback
     *
     * first example "puid=6" here => https://xmedias3.mannheimer-morgen.de/index.php?artikel=-hockenheim-experte-aus-hockenheim-aeussert-sich-zur-gruendung-eines-cannabisvereins-&arid=2183119&puid=6&pageid=2433
     * second example "_puid,6" here => https://xmedias3.mannheimer-morgen.de/orte/hockenheim_artikel,-hockenheim-experte-aus-hockenheim-aeussert-sich-zur-gruendung-eines-cannabisvereins-_arid,2183119_puid,6.html
     */
    const matchArray = window.location.href.match(REGEX_GET_PUID);
    if ( matchArray !== null
      && (pu = Number(matchArray[1]))
      && typeof pu === 'number' ) {
      return pu;
    }

    // Start check the domain
    let regEx = /^[^.]*./
    let domain = window.location.hostname;
    pu = 0;
    switch (domain.replace(regEx, '')) {
      case DOMAIN_MM:
        pu = PUID_MM;
        break;
      case DOMAIN_BA:
       pu = PUID_BA;
       break;
      case DOMAIN_SZ:
        pu = PUID_SZ;
        break;
      case DOMAIN_FN:
        pu = PUID_FN;
       break;
      default:
        pu = PUID_MM;
       break;
    }

    return pu;
  }

  /**
   * Get domain
   * @param {number} puId optionally, if not passed, the current request puId is fetched by getCurrentPuId()
   * @returns {string} e.g. 'mannheimer-morgen.de' or 'bergstraesser-anzeiger.de'
   */
  getDomain ( puId = null ) {

    // if puId not passed, the current request puId is fetched by getCurrentPuId()
    if ( typeof puId !== 'number' ) {
      puId = this.getCurrentPuId();
    }

    let domain;
    switch (puId) {
      case PUID_BA:
       domain = DOMAIN_BA;
       break;
      case PUID_SZ:
        domain = DOMAIN_SZ;
        break;
      case PUID_FN:
        domain = DOMAIN_FN;
       break;
      case PUID_MM:
      default:
        domain = DOMAIN_MM;
       break;
    }

    return domain;
  }

  getHostnameWithoutSubdomain() {
    const match = window.location.hostname.match(/([a-z0-9-]+\.[a-z]{2,})(\.localhost)?$/i);
    return match ? match[1] : window.location.hostname;
  }

  getSubdomain() {
    let host = window.location.hostname
    let subdomain = host.split('.')[0]

    return subdomain
  }

  getRedfactHostname () {
    return (new RedfactHelper()).getRedfactHostname();
  }


  isArticleDetailPage () {
    if(window.location.href.includes('arid')) {
      return true;
    } else {
      return false;
    }
  }

  isSelfservicePage () {
    return window.location.href.includes('selfservice');
  }

  isDevArticleDetailPage () {
    return window.location.href.match(/http:\/\/localhost:3000\/components\/preview\/pages-article/) !== null;
  }


  isPayStandalonePage () {
    // e.g. https://www.mannheimer-morgen.de/payment_action,checkoutflow_code,T19PTEJNRE5PNllCSVlENFQ3V0Q%3D.html
    // e.g. https://test9.mannheimer-morgen.de/index.php?action=checkoutflow&code=T181Vk81QjFDRk9IODZNTE5MNEg%3D&puid=3&pageid=3133
    return window.location.href.match(/action[,=]+checkoutflow/) !== null;
  }

  isMSIE() {
    return !!(window.navigator.userAgent.match(/MSIE/)
      || !!navigator.userAgent.match(/Trident.*rv\:11\./));
  }

  isMobileDevice() {
    if (navigator.userAgentData) {
      return navigator.userAgentData.mobile; // Gibt `true` zurück, wenn das Gerät mobil ist
    }
    // Fallback für Browser, die `userAgentData` nicht unterstützen
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  iOS() {
    return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  isAndroid(){
    return /(android)/i.test(navigator.userAgent);
  }

  /**
   * Nur redfact, www2 oder e-paper hostnamen sind valide und als redirect-ziele zugelassen
   * @param url string z.B. https://test8.mannheimer-morgen.de/orte/mannheim_puid,3.html
   * @returns {boolean}
   */
  isValidHaasHostname (url) {
    let valid = false;
    if ( url !== undefined
      && url.match(REGEX_HOSTNAME_REDFACT) !== null
      || url.match(REGEX_HOSTNAME_WWW2) !== null
      || url.match(REGEX_HOSTNAME_EPAPER) !== null ) {
      valid = true;
    }
    return valid;
  }

  /**
   * Nur redfact hostnamen sind valide und als redirect-ziele zugelassen
   * @param url string z.B. return false https://authapi-epaper.mannheimer-morgen.de/login.html?redirecturi=https%3A%2F%2Fe-paper.mannheimer-morgen.de%2Ftitles%2F
   *                   z.B. return true https://www.mannheimer-morgen.de/service/epaper.html
   * @returns {boolean}
   */
  isValidRedfactHostname (url) {
    let valid = false;
    if ( url !== undefined
      && url.match(REGEX_HOSTNAME_REDFACT) !== null ) {
      valid = true;
    }
    return valid;
  }

  isNewsAppEnv() {
    let userAgent = window.navigator.userAgent;

    switch (userAgent) {
      case USERAGENT_NEWSAPP_MM:
      case USERAGENT_NEWSAPP_BA:
      case USERAGENT_NEWSAPP_SZ:
      case USERAGENT_NEWSAPP_FN:
        return true;
    }
    return false;
  }
}
